export function openExternal(url) {
    if (typeof window === 'undefined') return;
    window.open(url, '_blank', 'noopener,noreferrer');
}
